import React, { useEffect, useState } from 'react';
import Gallery from 'react-photo-gallery';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDebounce } from 'use-lodash-debounce';
import Api from '../services/ApiService';
import SelectedImage from './modal/gallery/SelectedImage';
import LoadingPage from './LoadingPage';
import FileNotFound from './FileNotFound';
import MaterialSearch from './MaterialSearch';

const GoogleImageSearch = ({ query = '', onSelected = () => null }) => {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [searchQuery, setSearchQuery] = useState(query);
  const debouncedQuery = useDebounce(searchQuery, 1000);

  const handleClick = (event, image) => {
    const newImages = images.map((i, index) => {
      if (index !== image.index) {
        return i;
      }

      return {
        ...i,
        selected: !i.selected,
      };
    });

    setImages(newImages);
  };

  const getSelected = () => images.filter(x => x.selected);

  const clearSelected = () => {
    setImages(
      images.map(x => {
        x.selected = false;
        return x;
      })
    );
  };

  const fetchImages = () => {
    if (!searchQuery) {
      setImages([]);
      return;
    }

    setLoading(true);

    Api.get('search/google/image', { params: { q: searchQuery } })
      .then(res => {
        setImages(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderImages = () => {
    if (loading) {
      return <LoadingPage message="Fetching From Google" />;
    }

    if (!images.length) {
      return <FileNotFound>No Images Found</FileNotFound>;
    }

    return (
      <Gallery
        photos={images.map((image, index) => {
          return {
            key: String(index),
            src: image.url,
            index,
            width: image.width,
            height: image.height,
            selected: image.selected,
            uploading: false,
          };
        })}
        renderImage={({ ...props }) => <SelectedImage {...props} noMeta />}
        onClick={handleClick}
      />
    );
  };

  useEffect(() => {
    fetchImages();
  }, [query, debouncedQuery]);

  return (
    <div className="modal-attachments google">
      <div className="toolbar-wrapper">
        <div className="selection-toolbar">
          {getSelected().length > 0 ? (
            <div className="selection-details">
              <div className="toolbar-button mr-1" title="Cancel" onClick={clearSelected} style={{ cursor: 'pointer' }}>
                <i className="fal fa-times" />
              </div>
              {`${getSelected().length} selected`}
            </div>
          ) : (
            <div className="selection-details">Select Images</div>
          )}
          <div className="right-toolbar">
            <MaterialSearch
              value={searchQuery}
              onChange={event => setSearchQuery(event.target.value)}
              showResults={false}
            />
            <Button
              variant="secondary"
              className="ml-1"
              onClick={() => onSelected(getSelected())}
              disabled={!getSelected().length}
            >
              Upload Selected
            </Button>
          </div>
        </div>
      </div>
      <div className="attachments">{renderImages()}</div>
    </div>
  );
};

GoogleImageSearch.propTypes = {
  query: PropTypes.string,
  onSelected: PropTypes.func,
};

export default GoogleImageSearch;
